package org.hs_soft.runmynesto.domain.usecase.product.tab_product_general

import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_product_general.SaveDataAssistantFavoriteMessagesRepository


class SaveDataAssistantFavoriteMessagesUseCase
    (private val repository: SaveDataAssistantFavoriteMessagesRepository) {
    suspend operator fun invoke(assistant: String, email: String, favoriteMessages:List<String>): String? {
        return repository.saveDataAssistantFavoriteMessages(assistant = assistant, email = email, favoriteMessages=favoriteMessages)
    }
}